import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Label } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { RichTextEditor } from 'app/domains/common-ui/RichTextEditor';
export function ApprovalWorkflowInput() {
    const [field, , helpers] = useField('approvalContent');
    const handleChange = (value) => {
        helpers.setValue(value);
    };
    return (<Box flexDirection="column" gap="sm" mb="2xl">
      <Label>
        <Trans comment="Prompt content field label">Content</Trans>
      </Label>
      <RichTextEditor value={field.value} placeholder={t({ message: 'Enter your prompt here...', comment: 'Approval workflow prompt placeholder' })} onChange={handleChange}/>
    </Box>);
}
